import React, { useState } from "react";
import {
  dropdownContainer, dropdownHeader,
  dropdownListContainer, dropdownList, listItem,
  downIcon, openIcon
} from "./dropdown.mod.scss";
import {  ChevronDown } from "react-bootstrap-icons";

const Dropdown = ({ options, defaultIndex, onChange }) => {
  options = options.filter(op => op);
  const [isOpen, setIsOpen] = useState(false);
  const [index, setIndex] = useState(defaultIndex);

  const toggling = () => setIsOpen(!isOpen);

  const onOptionClicked = (newIndex) => () => {
    setIndex(newIndex);
    const optionValue = options[newIndex][0];
    setIsOpen(false);
    onChange(optionValue);
  };

  return (
    <div className={dropdownContainer}>
      <div className={dropdownHeader} onClick={toggling}>
        <h5>{ options[index][1] }</h5>
        <ChevronDown className={`${downIcon} ${isOpen ? openIcon : ""}`} />
      </div>
      {
        isOpen && (
          <div className={dropdownListContainer}>
            <ul className={dropdownList}>
              {options.map(([, option], newIndex) => (
                <li className={listItem} onClick={onOptionClicked(newIndex)} key={Math.random()}>
                  <h5>{ option }</h5>
                </li>
              ))}
            </ul>
          </div>
        )
      }
    </div>
  );
};

export default Dropdown;
